const sanlamBlue = '#0880BC';
const sanlamYellow = '#FCB718';
const sanlamPink = '#C53749';
const sanlamIndigo = '#162952';
const sanlamAccentBlue = '#e8f3f8';
const sanlamGrey = '#E7E8ED';
const supportRed = '#F5523C';
const supportGreen = '#32C284';
const supportYellow = '#F3C84B';
const supportBlue = '#1974FE';
const sanlamAccentGrey = '#9197A3';
const darkBlue = '#32335F';
const SanlamOrange = '#F9ac19';
const SanlamDarkOrange = '#f9a406';
const sanlamGrey2 = '#757575';
const sanlamDarkBlue = '#566684';
const sanlamGrey3 = '#DADADA';
const sanlamVeryDarkBlue = '#04336B';
const sanlamPureBlue = '#007AFF';
const sanlamDarkGrey = '#979797';
const sanlamDarkGrayishBlue = '#575E71';
const sanlamVeryLightgray = '#E6E6E6';
const white = '#FFFFFF';
const sanlamGreen = '#008466';
const sanlamDarkerBlue = '#172c51';
export {
  sanlamBlue,
  sanlamPink,
  sanlamYellow,
  sanlamIndigo,
  sanlamAccentBlue,
  sanlamGrey,
  supportRed,
  supportGreen,
  supportYellow,
  supportBlue,
  sanlamAccentGrey,
  darkBlue,
  SanlamOrange,
  SanlamDarkOrange,
  sanlamGrey2,
  sanlamDarkBlue,
  sanlamGrey3,
  sanlamVeryDarkBlue,
  sanlamPureBlue,
  sanlamDarkGrey,
  sanlamDarkGrayishBlue,
  sanlamVeryLightgray,
  white,
  sanlamGreen,
  sanlamDarkerBlue,
};
